import { render, staticRenderFns } from "./TeacherEduRecord.vue?vue&type=template&id=f8838260&scoped=true&"
import script from "./TeacherEduRecord.vue?vue&type=script&lang=js&"
export * from "./TeacherEduRecord.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEduRecord.vue?vue&type=style&index=0&id=f8838260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8838260",
  null
  
)

export default component.exports